export const IDENTITY_ENUM = {
  DRIVING_LICENCE: 'drivingLicence',
  PASSPORT: 'passport',
}

export default IDENTITY_ENUM
